import React from 'react';
import AdminTemplate from 'components/templates/AdminTemplate';
import { Grid, Typography } from '@material-ui/core';
import ImProductEntryManagement from 'components/organisms/ImProductEntryManagement';

export default function IMInventoryEntry() {
  return (
    <AdminTemplate>
      <Grid container justify="center" spacing={2}>
        <Grid item xs={12} sm={12} style={{ marginBottom: 10 }}>
          <Typography variant="h5" component="h1" align="center">
            Gestión de Entradas
          </Typography>
        </Grid>
      </Grid>
      <ImProductEntryManagement />
    </AdminTemplate>
  );
}
